import { combineReducers } from "redux";
import { userActionReducer } from "services/UserActionConfirm/reducer";
import { errorReducer } from "services/Error/reducer";
import { branchReducer } from "services/Branch/reducer";
import { brandReducer } from "services/Brand/reducer";
import { statusReducer } from "services/Status/reducer";
import { statusTypeReducer } from "services/StatusType/reducer";
import { sourceReducer } from "services/Source/reducer";
import { receiverReducer } from "services/Receiver/reducer";
import { countriesReducer } from "services/Countries/reducer";
import { rolesReducer } from "services/Roles/reducer";
import { tenantsReducer } from "services/Tenants/reducer";
import { validatorsObjectPropertiesReducer } from "services/ValidatorsForObjectProperties/reducer";
import { normalizersReducer } from "services/Normalizers/reducer";
import { usersReducer } from "services/Users/reducer";
import { publishRequestStatusesReducer } from "services/PublishRequestStatuses/reducer";
import { configCiTestCasesReducer } from "services/ConfigCiTestCases/reducer";
import { configCiTestCasesStatusesReducer } from "services/ConfigCiTestCasesStatuses/reducer";
import { platformsReducer } from "services/Platforms/reducer";
import { languagesReducer } from "services/Language/reducer";
import {siteGroupReducer} from "services/SiteGroup/reducer";
// import { messageReducer } from "services/Message/services";

const servicesReducer = combineReducers({
    userAction: userActionReducer,
    errors: errorReducer,
    branch: branchReducer,
    siteGroup: siteGroupReducer,
    brand: brandReducer,
    status: statusReducer,
    statusType: statusTypeReducer,
    source: sourceReducer,
    receiver: receiverReducer,
    countries: countriesReducer,
    roles: rolesReducer,
    tenants: tenantsReducer,
    validatorsObjectProperties: validatorsObjectPropertiesReducer,
    normalizers: normalizersReducer,
    users: usersReducer,
    publishRequestStatuses: publishRequestStatusesReducer,
    configCiTestCases: configCiTestCasesReducer,
    configCiTestCasesStatuses: configCiTestCasesStatusesReducer,
    platforms: platformsReducer,
    languages: languagesReducer
});

export { servicesReducer };
